import { render, staticRenderFns } from "./LivingOptionEdit.vue?vue&type=template&id=9decd970&scoped=true"
import script from "./LivingOptionEdit.vue?vue&type=script&lang=js"
export * from "./LivingOptionEdit.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionEdit.vue?vue&type=style&index=0&id=9decd970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9decd970",
  null
  
)

export default component.exports